<p class="text-danger" *ngIf="!eventTriggering">{{displayTime}} Seconds Left....</p>

